import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Table } from 'reactstrap';

import { color } from '~/assets/styles/colors';
import { symbolPriceFormatter } from '~/helpers/price';
import { ModalAprovar } from '~/components/Modal/AprovarPedido';
import { ModalVisualizar } from '~/components/Modal/VisualizarPedido';

import { ButtonAprovar, TrStyled } from './styles';

export function Pedidos(props) {
	const {
		user,
		lancamentos,
		toggleAprovar,
		setToggleAprovar,
		toggleVisualizar,
		setToggleVisualizar,
		setMeusPedidos,
		pagina,
		filtroStatus,
		filtroPesquisa,
		filtroData,
		setAtualizaNF
	} = props;

	const colorItem = {
		aprovado: color.green,
		concluido: color.green,
		recebido: color.orange,
		reprovado: color.red,
		pendente: color.yellow,
		pendenteNF: color.orange,
		title: color.red,
	};

	const [idPedido, setIdPedido] = useState('');
	const [numPedido, setNumPedido] = useState('');
	const [statusPedido, setStatusPedido] = useState('');
	const [statusNotas, setStatusNotas] = useState('');
	const [isMobile, setIsMobile] = useState(false);

	function renderStatus(param) {
		switch (param.toLowerCase()) {
			case 'aprovado':
				return 'Concluído';
			case 'concluido':
				return 'Concluido';
			case 'enviado':
				return 'Recebido';
			case 'reprovado':
				return 'Reprovado';
			case 'pendente':
				return 'Pendente';
			default:
				return 'Null';
		}
	}

	function renderColor(statusGeral, statusNota) {
		switch (statusNota) {
			case 'Concluído':
				return color.green;
			case 'NF Pendente':
				return color.orange;
			case 'Aguardando NF':
				return color.orange;
			case 'NF Recebida':
				return color.orange;
			case 'Pendente':
				return color.yellow;
			case 'Reprovado':
				return color.red;
			case 'pendentesalvar':
				return color.yello
			default:
				return 'Null';
		}
	}

	function verificaSeNotaFoiEnviada(nf) {
		if (user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor') {
			if ((nf.length === 0 || nf.length > 0) && ((nf[0] ? nf[0].status_nota_pedido === 'PENDENTE' : false) || (nf[0] ? nf[0].status_nota_pedido === 'PENDENTESALVAR' : false))) {
				return 'NF Pendente'
			}
			if (nf.length === 0) {
				return 'NF Pendente'
			}
			if (nf.length > 0 && (nf[0] ? nf[0].status_nota_pedido === 'ENVIADO' : false)) {
				return 'NF Enviada'
			}
			if (nf.length > 0 && (nf[0] ? nf[0].status_nota_pedido === 'CONCLUIDO' : false)) {
				return 'Concluído'
			}
		}
		if (user.dados.cargo.toLowerCase() === '') {
			if ((nf.length === 0 || nf.length > 0) && ((nf[0] ? nf[0].status_nota_pedido === 'PENDENTE' : false) || (nf[0] ? nf[0].status_nota_pedido === 'PENDENTESALVAR' : false))) {
				return 'Aguardando NF'
			}
			if (nf.length === 0) {
				return 'Aguardando NF'
			}
			if (nf.length > 0 && (nf[0] ? nf[0].status_nota_pedido === 'ENVIADO' : false)) {
				return 'NF Recebida'
			} if (nf.length > 0 && (nf[0] ? nf[0].status_nota_pedido === 'CONCLUIDO' : false)) {
				return 'Concluído'
			}
		}
		return 'NF Pendente'
	}

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 900); // Defina a largura de tela que considera como mobile
		};

		handleResize();

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return (
		<>
			<Table id="test-table-xls-button" responsive>
				<thead>
					<TrStyled>
						<th>Data</th>
						<th>Ref. Pedido</th>
						<th style={{ textAlign: 'left', paddingLeft: 22 }}>Solicitante</th>
						<th>Valor</th>
						<th>Status</th>
					</TrStyled>
				</thead>
				<tbody>
					{lancamentos.map((item, index) => {
						return (
							<tr style={{ textAlign: 'center' }} key={`${item.autorizacao}-${index}`}>
								<td>
									{moment(item.data_pedido).format(
										'DD/MM/YYYY'
									)}
								</td>
								<td style={{ textAlign: 'center' }}>{item.numero_pedido}</td>
								<td style={{ textAlign: 'left' }}>{item.nome}</td>
								<td>
									{symbolPriceFormatter(item.valor_pedido)}
								</td>
								<td
									style={{
										fontWeight: 'bold',
										textAlign: 'center',
										color: verificaSeNotaFoiEnviada(item.nota_fiscal) === 'Aguardando NF' ? color.orange : colorItem[item.status.toLowerCase() === 'reprovado' ? 'title' :
											renderStatus(item.nota_fiscal[0] ? item.nota_fiscal[0].status_nota_pedido : 'pendente').toLowerCase()
										],
									}}>
									{item.status.toLowerCase() ===
										'pendente' ? (
										<ButtonAprovar
											style={{
												width: `${isMobile && '100%'}`,
												whiteSpace: `${isMobile && 'nowrap'}`,
												marginRight: `${isMobile && '12px'}`,
												textAlign: `${isMobile && 'center'}`,
											}}
											onClick={() => {
												setIdPedido(
													item.id.toString()
												);
												setNumPedido(
													item.numero_pedido
												);
												setToggleAprovar(
													!toggleAprovar
												);
												setStatusPedido(item.status.toLowerCase())
											}}>
											Aprovação pendente
										</ButtonAprovar>
									) : (
										<>
											<button
												onClick={() => {
													setIdPedido(
														item.id.toString()
													);
													setNumPedido(
														item.numero_pedido
													);
													setToggleVisualizar(
														!toggleVisualizar
													);
													setStatusNotas(verificaSeNotaFoiEnviada(item.nota_fiscal));
												}}
												style={{
													fontWeight: 'bold',
													border: 0,
													backgroundColor: 'white',
													color: renderColor(item.status.toLowerCase(), verificaSeNotaFoiEnviada(item.nota_fiscal)),
												}}
												type="button">
												{item.status.toLowerCase() === 'pendente' && 'Pendente'}
												{item.status.toLowerCase() === 'aprovado' && verificaSeNotaFoiEnviada(item.nota_fiscal)}
												{item.status.toLowerCase() === 'reprovado' && 'Reprovado'}
											</button>
										</>
									)}
								</td>
							</tr>
						);
					})}
				</tbody>
			</Table>
			<ModalVisualizar
				statusPedido={statusPedido}
				statusNotas={statusNotas}
				user={user}
				setAtualizaNF={setAtualizaNF}
				idPedido={idPedido}
				numPedido={numPedido}
				tipo='solicitados'
				setToggle={setToggleVisualizar}
				toggle={toggleVisualizar}
			/>

			<ModalAprovar
				pagina={pagina}
				filtroData={filtroData}
				filtroPesquisa={filtroPesquisa}
				filtroStatus={filtroStatus}
				setMeusPedidos={setMeusPedidos}
				user={user}
				idPedido={idPedido}
				numPedido={numPedido}
				setToggle={setToggleAprovar}
				toggle={toggleAprovar}
			/>
		</>
	);
}
